import script from "./SuccessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccessModal.vue?vue&type=script&lang=ts&setup=true"

import "./SuccessModal.vue?vue&type=style&index=0&id=8f439e88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f439e88"]])

export default __exports__